import { setCookie, getCookie } from "@workspace/cookie-manager";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

const STORAGE_KEY = "inito_utm_params";

function getUTMsFromURL(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const utms: Record<string, string> = {};
  for (const key of UTM_KEYS) {
    const val = params.get(key);
    if (val) utms[key] = val;
  }
  return utms;
}

/** Capture UTMs from URL into sessionStorage (no consent needed). */
export function captureUTMs(): void {
  const utms = getUTMsFromURL();
  if (Object.keys(utms).length > 0) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
  }
}

/** Write captured UTMs to session cookies if consent has been given. */
export function persistUTMCookies(): void {
  if (getCookie("advertising_cookie_consent") !== "allow") return;

  let utms = getUTMsFromURL();
  if (Object.keys(utms).length === 0) {
    try {
      utms = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    } catch {
      return;
    }
  }

  for (const [key, value] of Object.entries(utms)) {
    setCookie(key, value); // no expires = session cookie
  }
}

/**
 * Read persisted UTMs from the consent-gated cookies (set by persistUTMCookies).
 * Used by the checkout URL builder so UTMs survive navigation away from the
 * original ad-tagged URL. Cookie-only (not sessionStorage) so UTMs reach
 * checkout only when advertising consent was granted — matching Rails.
 */
export function getPersistedUTMs(): Record<string, string> {
  if (typeof document === "undefined") return {};
  const utms: Record<string, string> = {};
  for (const key of UTM_KEYS) {
    const val = getCookie(key);
    if (val) utms[key] = val;
  }
  return utms;
}
